import React, { Component } from 'react';
import Select from 'react-select-plus';
import styled from 'styled-components';
import Icon from 'modules/common/components/Icon';
import debounce from 'lodash/debounce';
import { colors } from 'modules/common/styles';
import PropTypes from 'prop-types';
import { Alert, confirm } from 'modules/common/utils';
export const SelectValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -7px;
  padding-left: 25px;

  img {
    position: absolute;
    left: 0;
  }
`;

export const SelectOption = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Avatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: ${colors.bgActive};
  object-fit: cover;
  float: left;
  margin-right: 5px;
`;

const SelectWrapper = styled.div`
  // position: relative;

  .Select-clear-zone {
    visibility: hidden;
  }
`;

const ClearButton = styled.div`
  position: absolute;
  right: 18px;
  font-size: 16px;
  top: 50%;
  width: 18px;
  z-index: 2;
  color: #999;
  line-height: 24px;
  margin-top: -14px;

  &:hover {
    color: #ea475d;
    cursor: pointer;
  }
`;

class SelectWithSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: props.initialValues,
      selectedOptions: props.selectedOptions,
      totalOptions: props.totalOptions
    };
  }

  content(option) {
  const basename = process.env.PUBLIC_URL || "";

    return (
      <span>
        <Avatar
          src={option.avatar ? option.avatar : `${basename}/images/avatar-colored.svg`}
        />
        {option.label}
      </span>
    );
  }

  selectItemRenderer(option, showAvatar, OptionWrapper) {
    if (!showAvatar) {
      return option.label;
    }

    return <OptionWrapper>{this.content(option)}</OptionWrapper>;
  }
  componentWillReceiveProps(nextProps) {
    // const { queryName, customQuery, generateOptions } = nextProps;
    // const { selectedValues } = this.state;
    // if (customQuery.loading !== this.props.customQuery.loading) {
    //   const datas = customQuery[queryName] || [];
    //   const totalOptions = this.state.totalOptions || [];
    //   const totalOptionsValues = totalOptions.map(option => option.value);
    //   const uniqueLoadedOptions = generateOptions(
    //     datas.filter(data => !totalOptionsValues.includes(data._id))
    //   );
    //   const updatedTotalOptions = [...totalOptions, ...uniqueLoadedOptions];
    //   const selectedOptions = updatedTotalOptions.filter(option =>
    //     selectedValues.includes(option.value)
    //   );
    //   this.setState({
    //     totalOptions: updatedTotalOptions,
    //     selectedOptions
    //   });
    // }
  }

  renderClearButton = () => {
    if (!this.props.multi) {
      return null;
    }

    const { selectedValues = [] } = this.state;

    if (selectedValues.length > 0) {
      return (
        <ClearButton onClick={this.onClear}>
          <Icon icon="times" />
        </ClearButton>
      );
    }

    return null;
  };

  onClear = e => {
    confirm().then(() => {
      this.props.onSelect([], this.props.name);
      this.setState({ selectedValues: [], selectedOptions: [] });
    });
  };

  mergeSelect( totalOptions, initialValues ) {
    let duplicate = {};
    let result = [];
    totalOptions = totalOptions || []; 
    initialValues = initialValues || []; 
    initialValues.map(( item )=>{
      if( item.value ){
        duplicate[ item.value ] = true
        result.push(item);
      }
    })

    totalOptions.map(( item )=>{
      if( item.value && !duplicate[ item.value ] ){
        result.push(item);
      }
    })
    return result;
  }
  render() {
    const { __ } = this.context;
    const {
      loading,
      label,
      onSelect,
      initialValues,
      name,
      search,
      multi,
      customOption,
      showAvatar = true
    } = this.props;

    // console.log('this.props',this.props);

    const { totalOptions, selectedValues } = this.props;
    // console.log("select with search =---",totalOptions, selectedValues);
    const selectMultiple = ops => {
      const selectedOptionsValues = ops.map(option => option.value);

      onSelect(selectedOptionsValues, name, ops);

      this.setState({
        selectedValues: selectedOptionsValues,
        selectedOptions: [...ops]
      });
    };

    const selectSingle = option => {
      const selectedOptionValue = option ? option.value : '';

      onSelect(selectedOptionValue, name);

      this.setState({
        selectedValues: [selectedOptionValue],
        selectedOptions: [{ ...option }]
      });
    };

    const onChange = multi ? selectMultiple : selectSingle;

    const onSearch = searchValue => {
      if (searchValue) {
        debounce(() => search(searchValue), 1000)();
      }
    };

    const onOpen = () => search('reload');

    // const selectOptions = [...(totalOptions || []),...(initialValues || [])];
    const selectOptions = this.mergeSelect( totalOptions, initialValues );

    if (customOption) {
      selectOptions.unshift(customOption);
    }
    console.log("initialValues", initialValues);
    console.log("selectOptions", selectOptions);
    console.log("selectedValues", selectedValues);

    let optionRenderer;
    let valueRenderer;

    if (multi) {
      valueRenderer = option =>
        this.selectItemRenderer(option, showAvatar, SelectValue);

      optionRenderer = option =>
        this.selectItemRenderer(option, showAvatar, SelectOption);
    }
    //console.log('selectedValues[0]',selectedValues);
    return (
      <SelectWrapper>
        <Select
          placeholder={__(label)}
          value={multi ? selectedValues : (selectedValues)}
          loadingPlaceholder={__('Loading...')}
          isLoading={loading}
          onOpen={onOpen}
          onChange={onChange}
          optionRenderer={optionRenderer}
          valueRenderer={valueRenderer}
          onInputChange={onSearch}
          options={selectOptions}
          multi={multi}
        />
        {this.renderClearButton()}
      </SelectWrapper>
    );
  }
}
SelectWithSearch.contextTypes = {
  __: PropTypes.func
};
export default SelectWithSearch;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/SelectWithSearch.js